export default "__VITE_ASSET__cjLrO2sk__"